import { Component, Input, OnInit } from '@angular/core';
import { RowCell, SectionData } from '../../models/sections-model';

@Component({
  selector: 'ngx-category-renderer',
  templateUrl: './category-renderer.component.html',
  styleUrls: ['./category-renderer.component.scss']
})
export class CategoryRendererComponent implements OnInit {
  @Input()data:SectionData;
  @Input() edit:boolean = true;
  @Input() title:string;
  rowCells:RowCell[];
  layoutClass:string;
  
  constructor() { }

  ngOnInit(): void {
    console.log(this.data)
    this.rowCells = this.data.rowOptions.rowCells;
    this.layoutClass = this.data.rowOptions.layoutClass;
    if(this.layoutClass == "ProductRowLayoutEnum.THREE_COL_PORTRIAT"){
      this.layoutClass="col-3-portrait";
    }
    if(this.layoutClass == "ProductRowLayoutEnum.FOUR_COL_PORTRIAT"){
      this.layoutClass="col-4-portrait";
    }
    if(this.layoutClass == "ProductRowLayoutEnum.FIVE_COL_PORTRIAT"){
      this.layoutClass="col-5-portrait";
    }
    if(this.layoutClass == "ProductRowLayoutEnum.SIX_COL_PORTRIAT"){
      this.layoutClass="col-6-portrait";
    }
  }

}
